export default __webpack_public_path__ + "assets/images/019766a29bae9f2f2a9056041a786e65.png";